import React, { useState, useEffect } from "react";
import "./TestimonialsSection.css";

const testimonialsData = [
  {
    author: "Satisfied Client",
    role: "CEO of Company",
    message:
      "Pawan Kaaz has been our trusted partner for years. Their Kaaj Button services are unparalleled, and their commitment to quality is evident in every piece they deliver.",
    image: "https://picsum.photos/50/50?random=1",
  },
  {
    author: "Happy Customer",
    role: "CEO, P9 Jeans",
    message: "Quisque quis euismod lorem. Etiam sodales ac felis id interdum.",
    image: "https://picsum.photos/50/50?random=2",
  },
  {
    author: "Long-term Partner",
    role: "Manager,Demo Jeans",
    message:
      "Working with Pawan Kaaz has been a game-changer for our business. Their digital record-keeping and GST compliance make operations smooth and hassle-free.",
    image: "https://picsum.photos/50/50?random=3",
  },
];

const TestimonialsSection = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [animateDirection, setAnimateDirection] = useState("");

  const handleDotClick = (index) => {
    const direction = index > currentIndex ? "left" : "right";
    setAnimateDirection(direction);
    setCurrentIndex(index);
  };

  useEffect(() => {
    const timeout = setTimeout(() => {
      setAnimateDirection("");
    }, 500); // Match this duration with your CSS transition duration

    return () => clearTimeout(timeout);
  }, [currentIndex]);

  const currentTestimonial = testimonialsData[currentIndex];

  return (
    <section className="lg:px-40 px-4 lg:py-16 py:6 bg-gray-100 flex flex-col justify-center items-center ">
        {/* Text Content */}
        <div className={`md:w-1/2 p-4  testimonial-slide ${animateDirection}`}>
          <div className="text-4xl font-bold mb-4">
            <span className="text-gray-300 text-6xl">&ldquo;</span>
          </div>
          <p className="text-lg mb-6">{currentTestimonial.message}</p>
          <div className="flex items-center">
            <img
              src={currentTestimonial.image}
              alt="Author"
              className="w-12 h-12 rounded-full mr-4"
            />
            <div>
              <h4 className="text-xl font-bold">{currentTestimonial.author}</h4>
              <p className="text-gray-600">{currentTestimonial.role}</p>
            </div>
          </div>
        </div>

      {/* Pagination Dots */}
      <div className="flex justify-center mt-8">
        {testimonialsData.map((_, index) => (
          <div
            key={index}
            className={`w-3 h-3 mx-2 rounded-full cursor-pointer ${
              index === currentIndex ? "bg-black" : "bg-gray-500"
            }`}
            onClick={() => handleDotClick(index)}
          ></div>
        ))}
      </div>
    </section>
  );
};

export default TestimonialsSection;
